export class GetSiteResponseDto {
    id: number;
    crmId: number;
    triggerCategoryId: number;
    url: string;
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/models/GetSiteResponseDto.ts